import { render, staticRenderFns } from "./DeclutterReports.vue?vue&type=template&id=23f7ffbc&"
import script from "./DeclutterReports.vue?vue&type=script&lang=js&"
export * from "./DeclutterReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports